import { useState } from 'react'
import { useStorageState } from 'react-storage-hooks'
import { ViewType } from '../components/shared/ViewSwitcher'
import { PickingListSubmitResult, StagedPick } from '../api/api_data_types'
import type { ApiError } from '../components/helpers/error'

export default function usePickingListTableController() {
  const [changedQuantities, setChangedQuantities] = useState<Record<string, StagedPick>>({})
  const [saveAllError, setSaveAllError] = useState<ApiError | null>(null)
  const [submitResult, setSubmitResult] = useState<PickingListSubmitResult | null>(null)
  const [currentView, setCurrentView] = useStorageState<ViewType>(localStorage, 'pickingListCurrentView', 'table')

  return { saveAllError, setSaveAllError, submitResult, setSubmitResult, changedQuantities, setChangedQuantities, currentView, setCurrentView }
}
